/* eslint-disable import/prefer-default-export */
import List from '@mui/material/List'
import styled from 'styled-components'
export const ScrollView = styled(List)``
